<rpe-page-template title="GESTIÓN DE EMPRESA" route="main/landing">
  <ng-container slot="content">
   <div class="container">
  <div class="row">
    <div class="title">
      <h1 class="main-heading">{{ 'rpe.vista-mis-empresas.title' | translate }}</h1>
    </div>
  </div>
  <div class="row">
    <rpe-entity-mis-empresas-form-container></rpe-entity-mis-empresas-form-container>
  </div>
   </div>
  </ng-container>
</rpe-page-template>

